import { render } from "./CommissionsDetail.vue?vue&type=template&id=57cdedd6&ts=true"
import script from "./CommissionsDetail.vue?vue&type=script&lang=ts"
export * from "./CommissionsDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__